import { RootState } from '@/stores'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export interface useChannelFixingPositionResult {
  fixingPosition: 'top' | 'face'
}

const useChannelFixingPosition = (): useChannelFixingPositionResult => {
  const design = useSelector((state: RootState) => state.activeDesign.design)

  const fixingPosition = useMemo(() => {
    const castInChannel = design?.components.find((component) => {
      return Object.prototype.hasOwnProperty.call(component, 'cast_in_anchor_channel')
    })

    return castInChannel?.cast_in_anchor_channel?.fixing_position
  }, [design])

  return {
    fixingPosition,
  }
}

export default useChannelFixingPosition
